import React from "react";
import { Link } from "react-router-dom";
import DashboardHeader from "../../layouts/dashboard_header";
import SideMenu from "../../layouts/dashboard_menu";
import DashboardFooter from "../../layouts/dashboard_footer";
import Canvas from "../../layouts/dahboard_canvas";

type ServiceCenterShellTab = "center" | "my-services" | "categories" | "pricing" | "analytics";

interface ServiceCenterShellProps {
    title: string;
    description: string;
    activeTab: ServiceCenterShellTab;
    action?: React.ReactNode;
    children: React.ReactNode;
}

const tabs: Array<{ key: ServiceCenterShellTab; label: string; icon: string; to: string }> = [
    { key: "center", label: "Service Center", icon: "bx bx-home-alt", to: "/institution/service-center" },
    { key: "my-services", label: "My Services", icon: "bx bx-layer-group", to: "/institution/services/my-services" },
    { key: "categories", label: "Categories", icon: "bx bx-category-alt", to: "/institution/services/categories" },
    { key: "pricing", label: "Pricing", icon: "bx bx-dollar-circle", to: "/institution/services/pricing" },
    { key: "analytics", label: "Analytics", icon: "bx bx-bar-chart-alt-2", to: "/institution/services/analytics" },
];

const ServiceCenterShell: React.FC<ServiceCenterShellProps> = ({ title, description, activeTab, action, children }) => {
    return (
        <>
            <DashboardHeader />
            <SideMenu />
            <div className="main-content">
                <div className="page-content">
                    <div className="sc-wrap">
                        <div className="sc-header">
                            <div>
                                <h1>{title}</h1>
                                <p>{description}</p>
                            </div>
                            {action}
                        </div>
                        <div className="sc-tabs">
                            {tabs.map((tab) => (
                                <Link
                                    key={tab.key}
                                    to={tab.to}
                                    className={`sc-tab ${activeTab === tab.key ? "active" : ""}`}
                                    style={{ textDecoration: "none" }}
                                >
                                    <i className={tab.icon}></i> {tab.label}
                                </Link>
                            ))}
                        </div>
                        {children}
                    </div>
                </div>
                <DashboardFooter />
            </div>
            <Canvas />
        </>
    );
};

export default ServiceCenterShell;
